import Icon from '../components/Icon.vue'

Icon.register({
  subway: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 96v256c0 51.8-61.6 96-130 96l63 49.7c5.9 4.7 2.6 14.3-5 14.3h-304c-7.6 0-10.9-9.6-5-14.3l63-49.7c-68.2 0-130-44-130-96v-256c0-53 64-96 128-96h192c65 0 128 43 128 96zM200 232v-112c0-13.3-10.7-24-24-24h-104c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h104c13.3 0 24-10.7 24-24zM400 232v-112c0-13.3-10.7-24-24-24h-104c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h104c13.3 0 24-10.7 24-24zM352 288c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zM96 288c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z'
      }
    ]
  }
})
